/* eslint-disable */
import React, {PropTypes} from 'react';
import moment from 'moment';
var Datetime = require('react-datetime');
import AutenticarForm from './AutenticarForm'
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'
//
class Autenticar extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        //debugger;
        this.state = {
        };
    }



    render() {

    return (
        
        <div>
            <div className="breadcrumb-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <h2 className="title">Autenticar cliente</h2>
                        </div>
                        <div className="col-lg-6 col-md-6 col-xs-12 col-sm-6">
                            <div className="breadcrumbs pull-right">
                                <ul>
                                    <li>Você está aqui:</li>
                                    <li><a href={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()}>Home</a></li>
                                    <li>Autenticação</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div className="container">
                <div className="row">
                    <div className='row'>
                        <AutenticarForm {...this.props.params} />
                    </div>
                </div>
            </div>
        </div>
    );
  }
}


Autenticar.contextTypes = {
  router: React.PropTypes.object
};


export default Autenticar;



/** WEBPACK FOOTER **
 ** ./src/components/Autenticar.js
 **/